import { Content } from '@prismicio/client';
import { ProductCatalogService } from '@yol-digital/ms-client';
import { ProductListItem } from '../interfaces/product-list-item.interface';
import { Product } from '../interfaces/product.class';

export const productCatalogMockedResponse: ProductCatalogService.CatalogResponse = {
  availableLockings: [],
  activationFee: 0,
  basePrice: 100,
  productSpecCategory: '',
  productSpecClass: 'POSTPAID',
  displayName: 'test product',
  shortName: 'test-product',
  name: 'test-product',
  code: 'TEST_PRODUCT',
  id: 'rateplan_1234',
  productSpecFamily: 'mobile',
  source: 'zira',
  productSpecBrand: 'yallo',
  productSpecCode: 'TEST',
  defaultPromotion: null,
};

export const ratePlanMockedResponse: ProductCatalogService.RatePlanResponse = {
  productSpecClass: 'POSTPAID',
  displayName: 'test product',
  shortName: 'test-product',
  name: 'test-product',
  code: 'TEST_PRODUCT',
  productSpecFamily: 'mobile',
  source: 'zira',
  productSpecBrand: 'yallo',
  productSpecCode: 'TEST',
  category: 'test-category',
  basePrice: 100,
  availableLockings: [],
};

export const products = (prismicData?: Partial<Content.ProductBoxDocumentData>): ProductListItem[] => [
  {
    product: new Product(productCatalogMockedResponse, prismicData),
    promotion: undefined,
    featured: true,
    local: true,
    global: true,
    prepaid: true,
    all: true,
  },
  {
    product: new Product(productCatalogMockedResponse, prismicData),
    promotion: undefined,
    featured: true,
    local: true,
    global: false,
    prepaid: false,
    all: false,
  },
];
